<template>
    <!-- search section  -->
    <section class="container-4xl-w mx-auto w-full   px-3  md:none">
            <div class="w-full h-10 lg:h-12 flex items-center relative">
              <input          
                class="outline-none w-full h-8 lg:h-10 rounded-lg ps-[3.5rem] border-2 public-text-b text-gray-500 focus:ring-2 focus:ring-blue-600"
                v-model="searchTerm" @keyup.enter="handleEnter" @input="handleSearch" 
                aria-describedby="search-description"
                placeholder="جستجوی محصولات"
              />
              <button
               @click="selectProduct(searchTerm)"
                class="flex items-center justify-center absolute top-[4px] lg:top-[0.25rem] right-0 h-8 lg:h-[2.5rem] w-12 bg-gray-200 rounded-tr-md rounded-br-md hover:bg-sky-400 hover:text-white transition-all"
              >
               <font-awesome-icon icon="search"  />
              
              </button>
              <div v-if="searchTerm" class="text-gray-400 absolute top-1 lg:top-[9px] cursor-pointer left-[0.7px] hover:text-gray-500 bg-white py-1 px-2 rounded-md" @click="searchTerm=''"  aria-hidden="true" >
                    
                     <font-awesome-icon icon="close" class="h-4 w-4 " />
              </div>
              <ul v-if="filteredProducts.length > 0"  :class="activeList?'h-0':'max-h-[7.5rem] lg:max-h-32 shadow   shadow-blue-500 shadow-md'" class="absolute  top-10 lg:top-12 w-full right-12 overflow-auto rounded-md z-50 bg-white" style="width: calc(100% - 3rem);">
                    <li class="public-text1 text-gray-500 py-1 bg-white pr-2 hover:bg-gray-100 cursor-pointer"  v-for="product in filteredProducts" :key="product.id" @click="selectProduct(product.name)"
                   >{{ product.name }}
                    </li>       
              </ul>
            </div>

          </section>
  </template>
   <script setup>
     import {ref , computed,watchEffect,onMounted,onBeforeUnmount} from 'vue'
 
  import { useRouter } from 'vue-router';
  import { useSetProductStore } from '@/store/setProduct'
  const router=useRouter()
  const productStore=useSetProductStore();
  productStore.setProductFromApi()
  const searchTerm = ref('');
  const showSuggestions = ref(true); // Flag to control the visibility of the ul
  const products=computed(()=>productStore.getProduct)

  const activeList=ref(false);
  const searchResoult=()=>{
  if(searchTerm.value){
    activeList.value=true
  router.push({name:'search',query:{name:searchTerm.value}})
}
}
const handleEnter=()=>{
  searchResoult()
}
const filteredProducts = computed(() => {
  if (searchTerm.value.trim() === '' || searchTerm.value.length===1) {
    return []; // Return an empty array when searchTerm is empty or contains only spaces
  } else {
    return products.value.filter((product) =>
      product.name.toLowerCase().includes(searchTerm.value.toLowerCase().trim())
    );
  }
});
const handleSearch = () => {
  showSuggestions.value = true; // Show the suggestions when the user types
  activeList.value=false
  
};
const selectProduct = (productName) => {
  
  searchTerm.value = productName; // Set the input value to the clicked li's text
  showSuggestions.value = false; // Hide the suggestions when a li is clicked
  activeList.value=true
  searchResoult();
};
    // Handle clicks outside the search box to close the result list
    const handleClickOutside = () => {
        activeList.value=true;
    };

onMounted(()=>{
  window.addEventListener('click', handleClickOutside);

})

onBeforeUnmount(() => {
      window.removeEventListener('click', handleClickOutside);
    });
watchEffect(()=>{
  activeList.value=false
})

  
   </script>